import React from 'react';
import PropTypes from 'prop-types';

import FormCheckbox from '../../../../component-library/form-checkbox';
import FormField from '../../../../component-library/form-field';
import FormSelect from '../../../../component-library/form-select';

const BindingTypeFields = ({
	channelIndex,
	bindingTypeData,
	handleBindingDetailsChange,
}) => (
	<div className="get-api-access__form-row-2-col">
		{bindingTypeData.map((item, index) => (
			<div>
				{item.type === 'boolean' && (
					<FormCheckbox
						// eslint-disable-next-line react/no-array-index-key
						key={index}
						action={e => handleBindingDetailsChange(channelIndex, e.target.checked, item.id)}
						id={item.id}
						value={item.value}
						label={item.name}
					/>
				)}
				{(item.type === 'string' && item.subtype !== 'dropdown') && (
					<FormField
						type="text"
						label={item.name}
						action={e => handleBindingDetailsChange(channelIndex, e.target.value, item.id)}
						id={item.id}
						name={item.id}
						value={item.value}
						error={item.error}
						required={item.required}
						fullWidth
					/>
				)}
				{(item.type === 'number' && item.subtype !== 'dropdown') && (
					<FormField
						type="number"
						label={item.name}
						action={e => handleBindingDetailsChange(channelIndex, e.target.value, item.id)}
						id={item.id}
						name={item.id}
						value={item.value}
						error={item.error}
						required={item.required}
						fullWidth
					/>
				)}
				{(item.type === 'string-json' && item.subtype !== 'dropdown') && (
					<FormField
						type="text"
						label={item.name}
						action={e => handleBindingDetailsChange(channelIndex, e.target.value, item.id)}
						id={item.id}
						name={item.id}
						value={item.value}
						error={item.error}
						required={item.required}
						fullWidth
					/>
				)}
				{item.subtype === 'dropdown' && (
					<FormSelect
						// eslint-disable-next-line react/no-array-index-key
						key={index}
						label={item.name}
						placeholder="Please select..."
						data={item?.listValues.map(i => ({
							id: i.value,
							value: i.value,
							text: i?.label || i.value,
						}))}
						action={e => handleBindingDetailsChange(channelIndex, e.target.value, item.id)}
						id={item.id}
						name={item.id}
						value={item.value}
						required={item.required}
						error={item.error}
						fullWidth
					/>
				)}
			</div>
		))}
	</div>
);

export default BindingTypeFields;

BindingTypeFields.propTypes = {
	channelIndex: PropTypes.number.isRequired,
	bindingTypeData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	handleBindingDetailsChange: PropTypes.func.isRequired,
};
